/* eslint-disable camelcase */
const DesksCoreHoursOccupation = ({ databoxes: { textblock_data } }) =>
  `Throughout the core business hours of the week, occupied desks were
   generally observed at ${textblock_data.max_peaktime_avg_occup_percent}%.`;

export default DesksCoreHoursOccupation;
